import { render, staticRenderFns } from "./updatePickup.vue?vue&type=template&id=3edee2b8&scoped=true&"
import script from "./updatePickup.vue?vue&type=script&lang=js&"
export * from "./updatePickup.vue?vue&type=script&lang=js&"
import style0 from "./updatePickup.vue?vue&type=style&index=0&id=3edee2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edee2b8",
  null
  
)

export default component.exports